import { chipClasses } from "@mui/material";
import { forwardRef } from "react";

import AppChip, { AppChipProps } from "./AppChip";

export interface AppCounterChipProps extends Omit<AppChipProps, "label"> {
  count: number | null | undefined;
  max?: number;
}

export default forwardRef<HTMLDivElement, AppCounterChipProps>(function AppCounterChip(
  { count, max = 99, size = "medium", shape = "square", sx, ...otherProps }: AppCounterChipProps,
  ref,
) {
  const displayCount = (count ?? 0) > max ? `${max}+` : count;

  return (
    <AppChip
      ref={ref}
      sx={{
        height: 32,
        width: "unset",
        aspectRatio: "1 / 1",
        p: 0,
        fontSize: "inherit",

        [`& .${chipClasses.label}`]: {
          p: 0,
        },

        ...(size === "extraSmall" && {
          height: 20,
          fontSize: "small",
        }),
        ...(size === "small" && {
          height: 24,
          fontSize: "small",
        }),
        ...(size === "medium" && {
          height: 32,
        }),
        ...(size === "large" && {
          height: 40,
        }),

        ...sx,
      }}
      label={displayCount}
      size={size}
      shape={shape}
      {...otherProps}
    />
  );
});
